import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useTnC } from "../../hooks/useTnC";

import {
    Checkbox,
    FormControlLabel,
    Link,
} from "@mui/material";

const checkboxLabel = process.env.REACT_APP_TERM_AND_CONDITION_CHECKBOX_LABEL ?? "";
const linkColor = process.env.REACT_APP__UI_CUSTOMIZATION__TERMS_AND_CONDITION_TEXT_COLOR;
const linkHref: string = process.env.REACT_APP_TERM_AND_CONDITION_URL ?? "https://redir.sr-api.com/terms";
const privacyLinkHref: string = process.env.REACT_APP_PRIVACY_POLICY_URL ?? "";

interface TnCProps {
    showCheckbox?: boolean,
    tncChecked?: boolean,
    setTncChecked?: (value: boolean) => void,
}

export const TnC: React.FC<TnCProps> = props => {
    const {
        showCheckbox,
        tncChecked,
        setTncChecked,
    } = props;

    const { t } = useTranslation();

    const { accepted, setAccepted } = useTnC(tncChecked);

    const checked = typeof tncChecked === "boolean"
        ? tncChecked
        : accepted;

    const setIsTncChecked = typeof setTncChecked === "function"
        ? setTncChecked
        : setAccepted;

    return (
        <>
            {
                showCheckbox
                    ? (
                        <FormControlLabel
                            checked={checked}
                            control={
                                <Checkbox
                                    onChange={(event: ChangeEvent<HTMLInputElement>) => setIsTncChecked(event.target.checked)}
                                />
                            }
                            label={t(checkboxLabel)}
                            labelPlacement="end"
                            sx={{ margin: "0 auto", textAlign: "center" }} // Centered horizontally
                        />
                    )
                    : null
            }
            <Link
                href={linkHref}
                color={linkColor}
                underline="none"
                sx={{ textAlign: "center", marginTop: 1 }} // Centered horizontally
                target="_blank"
                rel="noreferrer"
                aria-label="To learn more, visit the Terms and Conditions page which opens in a new window."
            >
                {t("termsAndCondition")}
            </Link>
            {
                privacyLinkHref
                    ? (
                        <Link
                            href={privacyLinkHref}
                            color={linkColor}
                            underline="none"
                            sx={{ textAlign: "center", marginTop: 1 }} // Centered horizontally, sx's margin/padding 1 => 8px
                            target="_blank"
                            rel="noreferrer"
                            aria-label="To learn more, visit the Privacy Policy page which opens in a new window."
                        >
                            {t("privacy_policy")}
                        </Link>
                    )
                    : null
            }
        </>
    );
};
